import { useParams } from "react-router";
import { useRltConfirmationShowQuery } from "@/services/backend/rlt/confirmations/api/confirmation-api";
import { RTKQueryErrorAlert } from "@/shared/components/errors/rtk-query-error-alert";
import { CalculationComponent } from "@/routes/processes/[processId]/rlt/calculations/[calculationId]/calculation/calculation-route";
import { isImmutable } from "@/services/backend/documents/lib/document-state";

export function ConfirmationCalculationRoute() {
  const { confirmationId } = useParams();
  const {
    data: confirmation,
    isLoading,
    error,
  } = useRltConfirmationShowQuery({ id: confirmationId! });

  if (error) {
    return <RTKQueryErrorAlert error={error} />;
  }

  if (isLoading) {
    return null;
  }

  return (
    <CalculationComponent
      calculationId={confirmation!.calculationId}
      disabled={isImmutable(confirmation!)}
    />
  );
}
